<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-1">Порядок маршрутов</h4>
        <div class="text-muted">
          Перетащите маршруты в нужном порядке. Первый маршрут показывается первым в приложении.
        </div>
      </div>
      <div class="d-flex">
        <b-button variant="primary" class="mr-2" :disabled="loading || saving" @click="save">
          <b-spinner v-if="saving" small />
          <span v-else>Сохранить</span>
        </b-button>
        <b-button variant="outline-secondary" @click="$router.push({ name: 'Routes' })">
          Назад
        </b-button>
      </div>
    </div>

    <b-row>
      <b-col cols="12">
        <order-list
          title="Маршруты"
          description="Первый маршрут списка показывается первым в приложении."
          :items="routes"
          :loading="loading"
          :saving="saving"
          :show-edit="false"
          :show-header="false"
          @move="moveRoute"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import OrderList from '@/components/OrderList.vue';
import { DisplayOrder } from '@/request';

export default {
  name: 'RoutesOrder',
  components: { OrderList },
  data() {
    return {
      routes: [],
      loading: true,
      saving: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.routes = await DisplayOrder.getRoutesOrder();
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    moveRoute({ movedItemId, dropItemId, placement }) {
      const sourceIndex = this.routes.findIndex(({ id }) => id === movedItemId);
      if (sourceIndex === -1 || movedItemId === dropItemId) return;

      const reordered = [...this.routes];
      const [route] = reordered.splice(sourceIndex, 1);
      const dropIndex = reordered.findIndex(({ id }) => id === dropItemId);
      reordered.splice(placement === 'after' ? dropIndex + 1 : dropIndex, 0, route);
      this.routes = reordered;
    },
    async save() {
      this.saving = true;
      try {
        this.routes = await DisplayOrder.updateRoutesOrder(
          this.routes.map(({ id }) => id),
        );
        this.$bvToast.toast('Порядок маршрутов сохранён', { variant: 'success' });
      } catch (error) {
        this.showError(error);
      } finally {
        this.saving = false;
      }
    },
    showError(error) {
      const message = error.response?.data?.message || error.message;
      this.$bvToast.toast(message, { variant: 'danger' });
    },
  },
};
</script>
